import { computed, type ComputedRef } from 'vue';
import { useTouchLikeDevice } from '@/composables/useTouchLikeDevice';

/**
 * Element Plus `filterable` selects render a text input that opens the OS keyboard on touch devices.
 * Filtering is enabled only on desktop-like viewports with fine pointer.
 */
export function useSelectFilterable(): { isSelectFilterable: ComputedRef<boolean> } {
  const { isTouchLike } = useTouchLikeDevice();
  const isSelectFilterable = computed(() => !isTouchLike.value);

  return { isSelectFilterable };
}
